import { createFishEntryDrawer } from '../fishEntry/entryDrawer';

// /fangst — a landed fish. All behaviour lives in the shared factory; this file
// only supplies the catch-specific keys. `entryName` is simultaneously the
// fields.get() key, the FormFieldsCompact objectName, the incoming prop name
// (props.fishCatch) and the state key (state.fishCatch) — keeping it 'fishCatch'
// is what makes this refactor invisible to every existing caller and test.
//
// NB: `catch` is a JS reserved word — every identifier uses the fishCatch prefix.
export default createFishEntryDrawer({
    entryName: 'fishCatch',
    dateField: 'catchDate',
    testIdPrefix: 'fishcatch',
    titleId: 'fishCatch.title',
    titleDefault: 'Register catch',
});
